import { styled } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const POPOVER_LIST_WIDTH = 41;

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: theme.spacing(POPOVER_LIST_WIDTH),
    maxWidth: '100%',
  },
}));

/**
 * Notifications of the signed-in user, newest first, as `NotificationListItem` rows.
 * Fills a phone panel and keeps a readable 328px column inside a desktop popover.
 */
export function NotificationList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'notification-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as NotificationListProps };
